var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtitles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2825 38.2705H17.8521V35.2705H24.2825V38.2705Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9985 38.2705H46.8181V35.2705H26.9985V38.2705Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8181 43.6398H40.3877V40.6398H46.8181V43.6398Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8521 43.6398H37.6716V40.6398H17.8521V43.6398Z",
    fill: "currentcolor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2803 14C14.0711 14 12.2803 15.7909 12.2803 18V46C12.2803 48.2091 14.0711 50 16.2803 50H48.2803C50.4894 50 52.2803 48.2091 52.2803 46V18C52.2803 15.7909 50.4894 14 48.2803 14H16.2803ZM48.2803 17H16.2803C15.728 17 15.2803 17.4477 15.2803 18V46C15.2803 46.5523 15.728 47 16.2803 47H48.2803C48.8326 47 49.2803 46.5523 49.2803 46V18C49.2803 17.4477 48.8326 17 48.2803 17Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitles);
export default __webpack_public_path__ + "static/media/subtitles.f301550e.svg";
export { ForwardRef as ReactComponent };